import { useState, useEffect, useRef } from 'react';
import socketIO from 'socket.io-client';
import CustomAlert from './CustomAlert';



const useRoomSocket = (roomId, currentPatient, setCurrentPatient, nextPatient, setNextPatient, setChange, change) => {
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const socketRef = useRef(null);

    const handleAlertClose = () => {
        setAlertOpen(false);
    };
    const requestNotificationPermission = () => {
        if ('Notification' in window) {
            Notification.requestPermission().then((permission) => {
                if (permission === 'granted') {
                    console.log("Notification permission granted");
                } else {
                    console.log("Notification permission denied");
                }
            });
        } else {
            console.log("Notifications are not supported in this browser");
        }
    };


    useEffect(() => {
        console.log("roomId", roomId)
        requestNotificationPermission();

        // הפעלת אודיו שקט רק כשהדף נטען במלואו
        const playSilentAudioOnLoad = () => {
            const playSilentAudio = async () => {
                const audio = new Audio(); // אודיו ריק
                try {
                    await audio.play();
                    console.log("Audio permission granted");
                } catch (error) {
                    console.log("Failed to get audio permission:", error);
                }
            };
            playSilentAudio();
        };

        window.addEventListener("load", playSilentAudioOnLoad);


        socketRef.current = socketIO(process.env.REACT_APP_SERVICE_URL, {
            query: { clientId: roomId }
        });


        socketRef.current.on("queueUpdated", () => {
            console.log("queueUpdated")

        });

        socketRef.current.on("updateCurrentPatient", (newPatient) => {
            setCurrentPatient(newPatient);
            console.log("current patient", newPatient);
        });

        socketRef.current.on("updateNextPatient", (newPatient) => {
            setNextPatient(newPatient);
            console.log("next patient", newPatient);
        });

        socketRef.current.on("message", (message) => {
            setAlertMessage(message);
            setAlertOpen(true);
            console.log(message);
        });
        socketRef.current.on("Emergencymessage", (message) => {
            setAlertMessage(message);
            setAlertOpen(true);
            console.log(message);

            // יצירת התראה בשולחן העבודה
            showDesktopNotification('קריאה דחופה', {
                body: message
            });
        });

        socketRef.current.on("queueAmountUpdated", () => {
            console.log("updatedQueues wait")
            setChange(change++)

        });
        socketRef.current.on("deleteAllData", () => {
            window.location.reload()
        });


        return () => {
            socketRef.current.off("playAudio");  // Cleanup the listener on unmount
            window.removeEventListener("load", playSilentAudioOnLoad);

        };
    }, [roomId]);


    const moveRoom = (roomId) => {
        try {
            if (currentPatient.UniqueNumber == "") {
                alert("אין מטופל בחדר");
                console.log("not valid");
            }
            else {
                console.log("move client ", currentPatient.ID, " to room ", roomId);
                const place = true;
                socketRef.current.emit("moveClientToAnotherRoom", currentPatient.ID, roomId, place);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const emergencyAlertToDoctor = (patientId, roomId) => {
        try {
            if (patientId == null || roomId == null)
                alert("not valid");
            else {
                console.log("emergencyAlertToRoom", roomId, "for patient ", patientId);
                socketRef.current.emit("EmergencyAlertToRoom", roomId, patientId);
            }
        }
        catch (error) {
            console.log(error);
        }
    }

    const endOfTreatment = (patientId) => {
        try {
            if (patientId != null) {
                socketRef.current.emit("deletePatient", patientId);
                console.log("end of treatment of patient: ", patientId);
            }
            else {
                alert("not valid");
            }
        }
        catch (error) {
            console.log(error);
        }
    }


    const callPatientBroadcast = (queueNumber, roomNumber, roomID) => {
        console.log(queueNumber);
        if (!queueNumber) {
            console.log("queueNumber");
            socketRef.current.emit("inviteNextPatientToRoom", roomID);
        }
        else {
            socketRef.current.emit("playAudio", queueNumber, roomNumber);
        }

    }
    const showDesktopNotification = (title, options) => {
        if ('Notification' in window && Notification.permission === 'granted') {
            new Notification(title, options);
        } else {
            console.log("No permission to display notifications");
        }
    };

    return {
        emergencyAlertToDoctor,
        endOfTreatment,
        currentPatient,
        nextPatient,
        moveRoom,
        callPatientBroadcast,
        alertComponent: <CustomAlert open={alertOpen} onClose={handleAlertClose} message={alertMessage} />
    };
};


export default useRoomSocket;
